import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalyticsTracker = ({ trackingId }) => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        send_to: trackingId 
      });
    }
  }, [location, trackingId]);

  return null;
};

export default GoogleAnalyticsTracker;